import { Component, Input, TemplateRef, ViewChild } from "@angular/core";
import { DemoTemplateViewModel, DemoTileViewModel } from "src/app/core/model/ContentManagement";
import { DemoPopupComponent } from "../demo-popup/demo-popup.component";
import { MatDialog } from "@angular/material/dialog";
import { CreateInstancePopupComponent } from "../create-instance-popup/create-instance-popup.component";
import { TemplateDialogComponent, TemplateDialogData } from "src/app/shared/template-dialog/template-dialog.component";

@Component({
  selector: "brd-template-tile",
  templateUrl: "./template-tile.component.html",
  styleUrl: "./template-tile.component.less",
  standalone: false
})
export class TemplateTileComponent {
  @Input() template: DemoTemplateViewModel;
  @Input() enableAction = true;
  @Input() enableHover = true;
  @ViewChild("completeDialog", { read: TemplateRef })
  completeDialogTemplate!: TemplateRef<TemplateDialogData>;

  tileHover = false;

  public constructor(private readonly dialog: MatDialog) {}

  infoButtonClick(event: Event, demo: DemoTileViewModel): void {
    event.stopPropagation();
    const dialogRef = this.dialog.open(DemoPopupComponent, {
      width: "1115px",
      height: "700px",
      data: {
        demo
      }
    });

    dialogRef.afterClosed().subscribe();
  }

  createInstanceClick(event: Event): void {
    event.stopPropagation();
    const dialogRef = this.dialog.open(CreateInstancePopupComponent, {
      width: "1310px",
      height: "770px",
      data: {
        selectedTemplate: this.template
      }
    });

    dialogRef.afterClosed().subscribe(res => {
      if (res) {
        const completeDialogRef = this.dialog.open(TemplateDialogComponent, {
          width: "512px",
          height: "224px",
          data: {
            title: "Demo Environment going to be created!",
            templateVariable: this.completeDialogTemplate
          }
        });
        completeDialogRef.afterClosed().subscribe();
      }
    });
  }

  closeDialog(): void {
    this.dialog.closeAll();
  }
}
